import { usePaging } from 'hooks/usePaging';
import { useCallback } from 'react';
import { useGetCustomerGroupOptionsQuery, useGetServiceTypesOptionsQuery } from 'services';
import { FindAllCustomerGroupDto, FindAllServiceTypeDto, UseQueryOptionsType } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useCustomerGroupOptions(
  params: Omit<FindAllCustomerGroupDto, 'pageIndex' | 'pageSize'>,
  options?: UseQueryOptionsType
) {
  const { keyword, ...restParams } = params;
  const { pageIndex, resetPage, nextPage } = usePaging(params);
  const {
    data: dataResponse,
    isLoading,
    isFetching
  } = useGetCustomerGroupOptionsQuery(
    {
      pageIndex: pageIndex,
      pageSize,
      keyword,
      ...restParams
    },
    {
      ...options
    }
  );
  const { rows, count } = dataResponse?.data || {};

  const hasMore = Boolean(rows && count && rows.length < count);
  const handleLoadMore = useCallback(() => {
    if (hasMore && !isFetching) {
      nextPage();
    }
  }, [hasMore, pageIndex]);

  return {
    customerGroups: rows || [],
    count: count || 0,
    isFetching,
    isLoading,
    handleLoadMore,
    hasMore,
    resetPage
  };
}
